import { render, staticRenderFns } from "./Ministro.vue?vue&type=template&id=35f94f31&scoped=true&"
var script = {}
import style0 from "./Ministro.vue?vue&type=style&index=0&id=35f94f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f94f31",
  null
  
)

export default component.exports